import { SHStack } from "@components/design-systems";
import { FeeCalculatorRenderFieldProps } from "@models/platform-analysis/entities/steps/fee";
import { AnalysisVariable } from "@models/platform-analysis/enums/variableName";
import { memo } from "react";
import { FeeCalculatorCheckboxController } from "../../controllers/checkbox-controller";

export const FeeCalculatorInvestmentSelection = memo(
  ({ fieldConfig, disabled }: FeeCalculatorRenderFieldProps) => {
    const { selectionVariableNames } = fieldConfig;
    if (!selectionVariableNames) return null;

    return (
      <SHStack width={"100%"} sx={{ width: { xs: "100%", md: 520 } }}>
        {Object.keys(selectionVariableNames).map((variableName) => {
          const parsedVariableName = variableName as AnalysisVariable;
          const configs = selectionVariableNames[parsedVariableName];
          const disableConditions = configs?.disableConditions;
          const defaultValueWhenDisabled = configs?.defaultValueWhenDisabled;

          return (
            <FeeCalculatorCheckboxController
              disabled={disabled}
              key={parsedVariableName}
              variableName={parsedVariableName}
              disableConditions={disableConditions}
              defaultValueWhenDisabled={defaultValueWhenDisabled}
            />
          );
        })}
      </SHStack>
    );
  },
);
